module.exports = __webpack_public_path__ + "static/media/Frame 896.e7c4289f.png";